module.exports = __webpack_public_path__ + "img/Link.fa45531e.png";